import { render, staticRenderFns } from "./add-courses.vue?vue&type=template&id=0a7db754&scoped=true&"
import script from "./add-courses.vue?vue&type=script&lang=js&"
export * from "./add-courses.vue?vue&type=script&lang=js&"
import style0 from "./add-courses.vue?vue&type=style&index=0&id=0a7db754&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7db754",
  null
  
)

export default component.exports